import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { customerservice } from "../../../../config";
import CustomerForm from "../form";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../../theme";
import { CloudUpload } from "@mui/icons-material";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import { compact } from "lodash";

function ApprovedCustomers() {
  const base_url = customerservice.uri;

  // Define tour steps for the Rights page
  const rightsTourSteps = [
    {
      target: ".dynamic-table-header",
      content:
        "This is the Register Customer page, where you can manage new Customers before approving them.",
      placement: "top",
      disableBeacon: true,
    },
    {
      target: ".dynamic-table-search",
      content:
        "Use the search bar to find specific Customers by name or other criteria.",
      placement: "bottom",
    },
    {
      target: ".dynamic-table-add-button",
      content: "Click this button to add a new Customer.",
      placement: "right",
    },
    {
      target: ".edit-action",
      content: "Click this button to edit the Customer's Details.",
    },
    {
      target: ".view-customer-360-action",
      content:
        "Click this button to view the customer details place any attached images.",
    },
    {
      target: ".view-details-action",
      content:
        "Click this button to add or view customer's details like Next of kin, Guarantors, business detais and you can also find the customers loan data and bio data as well as collateral details.",
    },
    {
      target: ".map-to-employer-action",
      content:
        "Click this button to map the customer to an employer who will be added through the setups manaement module.",
    },
    {
      target: ".dynamic-table-actions",
      content:
        "Select actions like Edit or Deactivate for each Customer from this dropdown.",
      placement: "left",
    },
  ];

  const ignoreFields = [
    "CompanyName",
    "TitleId",
    "Password",
    "GenderId",
    "DateOfBirth",
    "MaritalStatusId",
    "PostalAddress",
    "PhysicalAddress",
    "ResidenceTypeId",
    "YearsLivedAtResidence",
    "CountyId",
    "WardId",
    "BranchId",
    "RegionId",
    "FieldOfficerId",
    "AccountLocked",
    "LoginAttempts",
    "FirstTimeLogin",
    "LoanLimit",
    "AverageCashSales",
    "DateCreated",
    "DeviceName",
    "DeviceId",
    "UniqueId",
    "LastLoginDateTime",
    "Pin",
    "Otp",
    "PinLastUpdated",
    "DateReactivated",
    "PostalCode",
    "ApprovalComments",
    "AverageSalesApproved",
    "AverageSalesApprovedBy",
    "AverageSalesApprovedDate",
    "AverageSalesReasonForRejection",
    "IdFrontPhoto",
    "IdBackPhoto",
    "CustomerVerified",
    "SelfiePhoto",
    "CustomerDeactivatedBy",
    "DeactivatedDate",
    "IsLoanScheduleGenerated",
    "DateOfLastLimitChange",
    "CreditInfoRecommendation",
    "ApprovedBy",
    "IsIPRSChecked",
    "UpdatedBy",
    "MigratedBy",
    "MigrationDate",
    "ServicedLoans",
    "InActiveOLB",
    "Latitude",
    "Longitude",
    "MappedBy",
    "GroupOLB",
  ];
  const columns = [
    { field: "Id", headerName: "CustomerID", flex: 1 },
    { field: "FirstName", headerName: "First Name", flex: 1 },
    { field: "OtherNames", headerName: "Other Names" },
    { field: "MobileNumber", headerName: "Customer Phone" },
    // { field: "EmailAddress", headerName: "Email Address" },
    { field: "IdNoOrPassport", headerName: "Id No Or Passport" },
    { field: "BranchName", headerName: "Branch" },
      { field: "Creator", headerName: "Created By" },
      { field: "DateCreated", headerName: "Created Date", width: 160 },
    {
      field: "ChannelId",
      headerName: "Channel",
      valueGetter: (params) => {
        const value = params.row.ChannelId;
        return value === 1 ? "Mobile" : "Portal";
      },
    },
    {
      field: "IsApproved",
      headerName: "Customer Approved",
      flex: 1,
    },
  ];
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const RoleGroupId = parseInt(decodedToken.RoleGroupId);
  const CompanyId = parseInt(decodedToken.CompanyId);
  let showActivate = false;
  let showApprove = false;
  if (CompanyId === 23) {
    if (RoleGroupId === 2) {
      showActivate = true;
    }
  }
  if (CompanyId === 29) {
    if (RoleGroupId === 2 || RoleGroupId === 4 || RoleGroupId === 1) {
      showApprove = true;
    }
  }

  const actions = {
    entity: "Register Customer",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: CompanyId === 23 ? showActivate : true,
      permission: "ActivatePermission",
      modelName: "customerIds", // Specify the model name here
      inputObjectName: "bulkActivateDeactivateCustomers",
    },
    ViewCustomerDetailsApproval: {
      key: "VIEWDETAILS",
      button_name: "ADD/View More Details",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },
    ViewCustomer360: {
      key: "ViewAllCustomerDetails",
      button_name: "View Customer 360",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },
    MapToEmployer: {
      key: "MAPTOEMPLOYER",
      button_name: "Map To Employer",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },
    ApproveDisapproveCustomer: {
      key: "APPROVEDISAPPROVECUSTOMER",
      button_name: "Approve/Disapprove Customer",
      Show_Button: CompanyId === 29 ? showApprove : true,
      permission: "ActivatePermission",
      // roleGroupId: [1, 2, 3, 4, 5],
    },

    dataObject: {
      ignoreFields,
      objectName: "allCustomersAwaitingApproval",
      parameters: "",
    },
    showMore: {
      objectname: "dynamicCustomerSearch",
      inputsubobjectname: "customer",
      parameters: "searchTerm",
      search: true,
      min: 3,
      max: 20,
      otherParams: 1,
      isCustomer: true,
      isAssetCustomer:0
    },
  };
  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleOpenModal = () => {
    setDialogOpen(true);
  };

  return (
    <Box m="2px">
      <Box
        m="2px"
        sx={{
          justifyContent: "end",
          alignItems: "center",
          display: "flex",
        }}
      >
        {" "}
        <Typography style={{ color: colors.greenAccent[400], margin: "0 8px" }}>
          Import Customer(s)
        </Typography>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUpload />}
          sx={{
            backgroundColor: colors.greenAccent[500],
            borderRadius: "4px",
            m: "10px",
          }}
          onClick={handleOpenModal}
        >
          <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
            Import
          </Typography>
        </Button>
      </Box>
      <DynamicTableForJson
        title="Customers"
        subtitle="View all customers, create edit or view details"
        FormComponent={CustomerForm}
        columns={columns}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
}

export default ApprovedCustomers;
